import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ManagePayOutRoutingModule } from './managepayout-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSortModule } from '@angular/material';
import { ManagepayoutComponent } from './managepayout.component';

@NgModule({
  declarations: [ManagepayoutComponent],
  imports: [
    CommonModule,
    NgbModule,
    ManagePayOutRoutingModule,    
    ReactiveFormsModule,
    MatchHeightModule,    
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatchHeightModule,    
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
  ]
})
export class ManagepayoutModule { }
